import frenchFlag from "@/assets/images/french_flag.svg";
import belgiumFlag from "@/assets/images/belgium_flag.svg";

export const LANGUAGE_FLAGS = [
  { value: "FR", image: frenchFlag },
  { value: "NL", image: belgiumFlag },
  // { value: "EN", image: unitedKingDomFlag }
];

export const LANGUAGE_CODES = {
  french: "FR",
  dutch: "NL",
  english: "ENG",
};

export const COUNTRY_CODE = {
  maroc: "MA",
  france: "FR",
  belgique: "BE",
  luxembourg: "LU",
  cote_d_ivoire: "CI",
  polynesie_française: "PF",
};

export const COUNTRIES = [
  {
    code: "FR",
    name: "France",
  },
  {
    code: "MA",
    name: "Maroc",
  },
  {
    code: "BE",
    name: "Belgique",
  },
  {
    code: "LU",
    name: "Luxembourg",
  },
];

export const DOM_START_POSTAL_CODE = [
  {
    code: "971",
    name: "Martinique",
  },
  {
    code: "972",
    name: "Guadaloupe",
  },
  {
    code: "973",
    name: "Guyane",
  },
  {
    code: "974",
    name: "Réunion",
  },
  {
    code: "976",
    name: "Mayotte",
  },
];

export const POLYNESIE_CASE_START_CODE = "987";
export const CALEDONIE_AGENCY_START_POSTAL_CODE = "988";

export const TOM_AGENCIES_START_CODE = [
  POLYNESIE_CASE_START_CODE,
  CALEDONIE_AGENCY_START_POSTAL_CODE,
];

export const IS_TOM_AGENCY = (postalCode) => {
  return (
    !!postalCode &&
    TOM_AGENCIES_START_CODE.some((code) => postalCode.startsWith(code))
  );
};
